<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss"></style>
<template>
  <div style="display: flex;width: 100%;">
    <!--    <div style="display: flex;width: 100%;height: 473px;">-->
    <el-tabs tab-position="left">
      <el-tab-pane :label="$t('xianshimoban')" style="padding: 0px 56px;">
        <div v-if="false" class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shifouxianshi') }}
          </p>
        </div>
        <div>
          <el-radio v-model="monitorSetting.MONITOR_TEMPLATE" label="moren">{{ $t('moren') }}</el-radio>
          <el-radio v-model="monitorSetting.MONITOR_TEMPLATE" label="shebeijiankong">{{ $t('shebeijiankong') }}</el-radio>
          <el-radio v-model="monitorSetting.MONITOR_TEMPLATE" label="shebeijiankong_xiaolvchanliang">{{ $t('shebeijiankong+xiaolvchanliang') }}</el-radio>
          <el-radio v-model="monitorSetting.MONITOR_TEMPLATE" label="shebeijiankong_baojingxinxi">{{ $t('shebeijiankong+baojingxinxi') }}</el-radio>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('shebeijiankong')" style="padding: 0px 56px;">
        <div v-if="false" class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shifouxianshi') }}
          </p>
        </div>
        <div v-if="false" style="display: flex;align-items: center;margin-top: 12px;">
          <p>{{ $t('xianshi') }}</p>
          <el-switch style="margin-left: 10px;" v-model="monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD" active-color="#419FFF"> </el-switch>
        </div>
        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 0px;">
          <!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shebeizhuangtai') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <div style="display: flex;flex-direction: column;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE" label="moren">{{ $t('moren') }} </el-radio>
          </div>
          <div style="display: flex;flex-direction: column;margin-left: 80px;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE" label="yincanglixianzhuangtai">
              {{ $t('yincanglixianzhuangtai') }}
            </el-radio>
          </div>
        </div>
        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
          <!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shebeikapianyangshi') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <div style="display: flex;flex-direction: column;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="jianyue">{{ $t('jianyue') }} </el-radio>
            <img style="width: 161px;height: 204px;margin-top: 12px;" src="../../../../assets/img/web/workshop/jianyue.jpg" />
          </div>
          <div style="display: flex;flex-direction: column;margin-left: 80px;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="tianchong">
              {{ $t('tianchong') }}
            </el-radio>
            <img style="width: 161px;height: 204px;margin-top: 12px;" src="../../../../assets/img/web/workshop/tianchong.jpg" />
          </div>
        </div>

        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('kapiankuandu') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;">
          <!-- <p>{{$t('meigekapiankuandu')}}</p> -->
          <el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH"></el-input-number>
          <p style="margin-left: 12px;">px</p>
        </div>

        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('kapianziti') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;">
          <!-- <p>{{$t('kapianzitidaxiao')}}</p> -->
          <el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.MONITOR_WORKSHOP_CARD_FONT"></el-input-number>
          <p style="margin-left: 12px;">px</p>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('kapianneirong')" style="padding: 0px 56px;">
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <div style="display: flex;flex-direction: column;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE" label="moren">{{ $t('moren') }} </el-radio>
          </div>
          <div style="display: flex;flex-direction: column;margin-left: 80px;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE" label="zhixianshiyunxingzhunagtaishebeixiangqing">
              {{ $t('zhixianshiyunxingzhunagtaishebeixiangqing') }}
            </el-radio>
          </div>
        </div>
        <!--        <div>-->
        <!--          <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE" label="moren">{{ $t("moren") }}</el-radio>-->
        <!--          <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE" label="zhixianshiyunxingzhunagtaishebeixiangqing">{{ $t("zhixianshiyunxingzhunagtaishebeixiangqing") }}</el-radio>-->
        <!--        </div>-->
      </el-tab-pane>
      <el-tab-pane :label="$t('qitaxinxi')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('kanbanbiaoti') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;width: 500px">
          <!--          @input="updateInput"-->
          <el-input style="margin-left: 12px;" size="mini" v-model="monitorSetting['IS_MONITOR_WORKSHOP_HEADER_' + store.state.customer.id]"></el-input>
          <div style="margin-left: 10px">-</div>
          <el-input style="margin-left: 12px;" size="mini" v-model="monitorSetting['MONITOR_WORKSHOP_CARD_TITLE_' + store.state.customer.id]"></el-input>
        </div>

        <div class="titleBar" style="display: flex;align-items:center;padding-top: 14px;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('gundongsudu') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;">
          <div style="width: 400px;margin-bottom: 40px;margin-left: 15px">
            <el-slider v-model="monitorSetting.MONITOR_WORKSHOP_CARD_SPEED" :step="1" show-stops :max="10" :min="1" :marks="marks" style="word-break: keep-all"> </el-slider>
          </div>
        </div>
        <div class="titleBar" style="display: flex;align-items:center;padding-top: 14px;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('baojingxinxiziti') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;">
          <!-- <p>{{$t('kapianzitidaxiao')}}</p> -->
          <el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.MONITOR_WORKSHOP_ALERT_FONT"></el-input-number>
          <p style="margin-left: 12px;">px</p>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="false" :label="$t('xiaolvzhibiao')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shifouxianshi') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <p>{{ $t('xianshi') }}</p>
          <el-switch style="margin-left: 10px;" v-model="monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE" active-color="#419FFF"> </el-switch>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="false" :label="$t('meixiaoshichanliang')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shifouxianshi') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <p>{{ $t('xianshi') }}</p>

          <el-switch style="margin-left: 10px;" v-model="monitorSetting.IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT" active-color="#419FFF"> </el-switch>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="false" :label="$t('baojingxinxi')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shifouxianshi') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <p>{{ $t('xianshi') }}</p>
          <el-switch style="margin-left: 10px;" v-model="monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT" active-color="#419FFF"> </el-switch>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="false" :label="$t('quanjushezhi')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('heianmoshi') }}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <p>{{ $t('kaiqi') }}</p>
          <el-switch style="margin-left: 10px;" v-model="monitorSetting.IS_MONITOR_WORKSHOP_BLACK" active-color="#419FFF"> </el-switch>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_setting',
  components: {},

  data() {
    return {
      monitorSetting: {},
      marks: { 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8', 9: '9', 10: '10' },
      titleName: null
    };
  },
  created() {
    this.resetData();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  methods: {
    resetData() {
      //可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }

      //每个单独初始化可以进行增量初始化，而不是一整个setting初始化
      this.monitorSetting.MONITOR_TEMPLATE = this.monitorSetting.MONITOR_TEMPLATE != null ? this.monitorSetting.MONITOR_TEMPLATE : 'moren';
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD != null ? this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD : true;

      this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE = this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_TYPE : 'moren';
      this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE = this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE : 'jianyue';
      this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH = this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH : 176;
      this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT = this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT : 14;
      this.monitorSetting.MONITOR_WORKSHOP_ALERT_FONT = this.monitorSetting.MONITOR_WORKSHOP_ALERT_FONT != null ? this.monitorSetting.MONITOR_WORKSHOP_ALERT_FONT : 14;

      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE != null ? this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE : true;
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT != null ? this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT : true;
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT != null ? this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT : true;
      this.monitorSetting.IS_MONITOR_WORKSHOP_BLACK = this.monitorSetting.IS_MONITOR_WORKSHOP_BLACK != null ? this.monitorSetting.IS_MONITOR_WORKSHOP_BLACK : true;
      this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED = this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED : 1;
      this.monitorSetting['IS_MONITOR_WORKSHOP_HEADER_' + this.store.state.customer.id] = this.monitorSetting['IS_MONITOR_WORKSHOP_HEADER_' + this.store.state.customer.id] != null ? this.monitorSetting['IS_MONITOR_WORKSHOP_HEADER_' + this.store.state.customer.id] : this.store.state.customer.shortName;
      this.monitorSetting['MONITOR_WORKSHOP_CARD_TITLE_' + this.store.state.customer.id] = this.monitorSetting['MONITOR_WORKSHOP_CARD_TITLE_' + this.store.state.customer.id] != null ? this.monitorSetting['MONITOR_WORKSHOP_CARD_TITLE_' + this.store.state.customer.id] : this.$t('chejianjiankong');
      this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE = this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE != null ? this.monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE : 'moren';
      this.monitorSetting.MONITOR_TEMPLATES = {
        moren: [
          {
            x: 0,
            y: 0,
            w: 8,
            h: 6, //应该是6
            i: 'oee'
          },
          {
            x: 8,
            y: 0,
            w: 12,
            h: 6, //应该是6
            i: 'hour_output'
          },
          {
            x: 20,
            y: 0,
            w: 4,
            h: 24,
            i: 'alert'
          },
          {
            x: 0,
            y: 6,
            w: 20,
            h: 18, //应该是18
            i: 'card'
          }
        ],
        shebeijiankong: [
          {
            x: 0,
            y: 6,
            w: 24,
            h: 24, //应该是18
            i: 'card'
          }
        ],
        shebeijiankong_xiaolvchanliang: [
          {
            x: 0,
            y: 0,
            w: 10,
            h: 6, //应该是6
            i: 'oee'
          },
          {
            x: 10,
            y: 0,
            w: 14,
            h: 6, //应该是6
            i: 'hour_output'
          },
          {
            x: 0,
            y: 6,
            w: 24,
            h: 18, //应该是18
            i: 'card'
          }
        ],
        shebeijiankong_baojingxinxi: [
          {
            x: 20,
            y: 0,
            w: 4,
            h: 24,
            i: 'alert'
          },
          {
            x: 0,
            y: 0,
            w: 20,
            h: 24, //应该是18
            i: 'card'
          }
        ]
      };
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 500);
    },
    save() {
      // localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting));
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
      console.log('cccccccccccccccccccccc', JSON.stringify(this.monitorSetting));
      this.utils.event_hub.$emit('SetLayoutWorkshop');
      this.utils.event_hub.$emit('SetCard');
    }
  }
};
</script>
